import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import TopFieldContent from '../../../Components/Form/components/TopFieldContent';
import useFormName from '../../../Hooks/useFormName';
import { joinClasses } from '../../../Utils/className.util';
import PrescriptionMedicamentsSelect from './PrescriptionMedicamentsSelect';

interface PrescriptionMedicamentsSelectFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
}

const PrescriptionMedicamentsSelectField: React.FC<
	PrescriptionMedicamentsSelectFieldProps
> = ({ name, label, isRequired, className }) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName || '',
		defaultValue: {},
	});

	return (
		<div className={joinClasses(['flex-grow-1', className])}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<PrescriptionMedicamentsSelect
				error={error}
				value={{ value: field.value?.id, label: field.value?.label }}
				onChange={field.onChange}
			/>
		</div>
	);
};

export default PrescriptionMedicamentsSelectField;
